import controller from './pop-info.controller';
import template from './pop-info.html';

export default {
	template,
	controller,
	bindings: {
		code: '@',
	},
};
